module.exports = __webpack_public_path__ + "media/images/mypage/mymenu_1_ov-3f3881111bd78704d3b1306d9008ff57.gif";